module.exports = __webpack_public_path__ + "fonts/PlayfairDisplay-VariableFont_wght.5c26cb0a.ttf";